<div
  *ngIf="!!status"
  class="status-cell status-cell-{{status}}"
>
  <span *ngIf="showSpinner" class="status-spinner" aria-hidden="true"></span>
  <span
    class="status-cell-text"
    [innerHTML]="status | splitCamelCase | highlight : searchQuery"
  ></span>
</div>
